import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import { useSingleProjectContext } from '@/context/SingleProjectContext'
import { ORG_DATABASE_ROUTE, PROJECT_ROUTE } from '@/shared/constants'

export function useIsProjectDb() {
  const location = useLocation()
  const { project } = useSingleProjectContext()
  return useMemo(() => {
    const split = location.pathname.split('/')
    const isDb = split[3] === ORG_DATABASE_ROUTE
    return project && isDb && location.pathname.startsWith(PROJECT_ROUTE)
  }, [location, project])
}
